
@if (doesUserHaveAccess) {
  <div class='apm-sso-container'>
    <a (click)="runSSO($event)">{{ apmLabel }}</a>
  </div>
} @else {
  <div class="loading-container warning-message">
    {{ noEntitlementsMessage || 'Your currently selected agency does not have access to log in to APM SSO. Try
    a different agency if available.'}}
  </div>
}

